import * as React from "react";
import { useHistory } from "react-router-dom";
import { Input, Button, Checkbox, message, DatePicker } from "antd";
import styled from "styled-components";
import { conference } from "@/api";
import { BoolType, ConfefenctType } from "@/types";
import { useAuth } from "@/component/Auth";
import moment from "moment";
import { time } from "@/util";

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 280px;
  .atitle {
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
    color: #999;
    margin-top: 20px;
  }
  .form {
    width: 280px;
  }
  .footer {
    height: 50px;
    display: flex;
    flex-direction: line;
    justify-content: center;
    align-items: center;
    width: 100%;
    .cancel {
      margin-left: 70px;
    }
  }
  .item {
    width: 420px;
    padding: 10px;
  }
  .fitem {
    width: 420px;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

const Create = (props: any) => {
  const history = useHistory();

  const auth = useAuth();
  const { loginfo } = auth;

  const [title, setTitle] = React.useState("");
  const [beginTime, setBeginTime] = React.useState(moment().subtract(1, "days"));
  const [endTime, setEndTime] = React.useState(moment().year(2099));
  const [passwordEnable, setPasswordEnable] = React.useState(BoolType.no);
  const [password, setPassword] = React.useState("");
  const [ownerPassword, setOwnerPassword] = React.useState("");
  const [allowEarlyEntry, setAllowEarlyEntry] = React.useState(BoolType.yes);
  const [muteJoinMeeting, setMuteJoinMeeting] = React.useState(BoolType.yes);
  const [allowSelfUnmute, setAllowSelfUnmute] = React.useState(BoolType.yes);
  const [playTips, setplayTips] = React.useState(BoolType.no);

  const create = async () => {
    if (passwordEnable === BoolType.yes && !password) {
      message.error("请输入会议密码");
      return;
    }
    await conference.manageCreate({
      title,
      beginTime: time.format(beginTime),
      endTime: time.format(endTime),
      allowEarlyEntry,
      muteJoinMeeting,
      playTips,
      allowSelfUnmute,
      passwordEnable,
      useSelfConference: BoolType.yes,
      type: ConfefenctType.appointment,
      conferenceNo: loginfo.conferenceNo,
      password,
      ownerPassword,
    });
    message.success("新建会议成功!");
    history.goBack();
  };

  const titleChange = (e: any) => setTitle(e.target.value);

  const handlePasswordChange = (val: string) => {
    val = val.replace(/[^\d]/g, '');
    setPassword(val);
  }

  return (
    <Container>
      <div className="atitle">新建会议</div>
      <div className="item">
        <Input placeholder="请输入会议主题" onChange={titleChange} />
      </div>
      {/* <div className="fitem">
        <DatePicker
          //value={beginTime}
          showTime
          onChange={setBeginTime}
          placeholder="会议开始时间"
        />
         <DatePicker
          //value={endTime}
          showTime
          onChange={setEndTime}
          placeholder="会议结束时间"
        />
      </div> */}
      <div className="fitem" style={{ height: 52}}>
        <Checkbox
          checked={passwordEnable === BoolType.yes}
          onChange={(e) =>
            setPasswordEnable(e.target.checked ? BoolType.yes : BoolType.no)
          }
        >
          设置会议密码
        </Checkbox>
        {passwordEnable === BoolType.yes && (
          <Input
            style={{ width: 280 }}
            placeholder="请输入会议密码"
            value={password}
            onChange={(e) => handlePasswordChange(e.target.value)}
          />
        )}
      </div>
      {/* <div className="item">
        <Input
          placeholder="请输入主持人密码"
          value={ownerPassword}
          onChange={(e) => setOwnerPassword(e.target.value)}
        />
      </div> */}
      {/* <div className="item">
        <Checkbox
          checked={allowEarlyEntry === BoolType.yes}
          onChange={(e) =>
            setAllowEarlyEntry(e.target.checked ? BoolType.yes : BoolType.no)
          }
        >
          允许成员在主持人进入会前加入会议
        </Checkbox>
      </div> */}
      <div className="item">
        <Checkbox
          checked={muteJoinMeeting === BoolType.yes}
          onChange={(e) =>
            setMuteJoinMeeting(e.target.checked ? BoolType.yes : BoolType.no)
          }
        >
          会员入会时静音
        </Checkbox>
      </div>
      <div className="item">
        <Checkbox
          checked={allowSelfUnmute === BoolType.yes}
          onChange={(e) =>
            setAllowSelfUnmute(e.target.checked ? BoolType.yes : BoolType.no)
          }
        >
          允许成员自我解除静音
        </Checkbox>
      </div>
      <div className="item">
        <Checkbox
          checked={playTips === BoolType.yes}
          onChange={(e) =>
            setplayTips(e.target.checked ? BoolType.yes : BoolType.no)
          }
        >
          成员加入会议时播放提示音
        </Checkbox>
      </div>

      <div className="footer">
        <Button type="primary" onClick={create}>
          新建
        </Button>
        <Button danger type="primary" className="cancel" onClick={() => history.goBack()}>
          取消
        </Button>
      </div>
    </Container>
  );
};

export default Create;
